import { useDispatch } from "src/store";

import { showDetails } from "@dashboard/devices/store";
import { MinimalTableCell } from "@shared/table/MinimalTableComponents";

import { Rollout } from "../../types";
import { rolloutStatusLabel } from "../../utils/rolloutStatus";

type Props = {
    id: number;
    status: Rollout["status"];
};

export const RolloutStatusCell = ({ id, status }: Props) => {
    const dispatch = useDispatch();

    const onRollout = () => {
        dispatch(showDetails({ type: "rollout", selectedId: id }));
    };

    return <MinimalTableCell onClick={onRollout}>{rolloutStatusLabel[status]?.() ?? status}</MinimalTableCell>;
};
